import { Col, Row, Modal, Form, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import { ModifierType } from "./ModifierType";
import { createModifier, editModifier } from "../../../api/modifier";
import { useState, useEffect, Dispatch } from "react";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import Title from "../../UI/Title/Title";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";

type propsType = {
  id?: string | number;
  openModifier: boolean;
  Modifier?: ModifierType | undefined;
  setOpenModifier: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  filter: boolean | undefined;
  search: string;
  setPaginatedModifier: Dispatch<any>;
  ModifierMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
};
export const AddEditModifier = ({
  openModifier,
  Modifier,
  setOpenModifier,
  id,
  page,
  filter,
  search,
  setPaginatedModifier,
  ModifierMutation,
}: propsType) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const [isActive, setIsActive] = useState<boolean>(
    Modifier ? Modifier?.isActive : true
  );
  const isEdit = () => {
    return !!id && id !== undefined && id !== "";
  };

  const onError = (error: any, variables: ModifierType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createModifier" : " editModifier",
    !isEdit()
      ? (modifier: ModifierType) => createModifier(modifier)
      : (modifier: ModifierType) => editModifier(id, modifier),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenModifier(false);
        message.success("Complete successfully");
        ModifierMutation({
          q: search,
          isActive: filter,
          limit: page * 8 + 8,
        }).then((res: any) => {
          setPaginatedModifier(res.data?.data);
        });
      },
      onError,
    }
  );
  const handleFinish = () => {
    const newmodifier = form.getFieldsValue();
    for (const key in newmodifier) {
      if (newmodifier[key] === undefined) {
        if (key === "isActive") {
          newmodifier[key] = true;
        } else {
          newmodifier[key] = null;
        }
      } else if (
        typeof newmodifier[key] === "string" &&
        newmodifier[key].trim() === ""
      ) {
        newmodifier[key] = null;
      }
    }
    mutateCreateUpdate(newmodifier);
  };
  const [inputValue, setInputValue] = useState(false);

  const handleInputChange = (event: any) => {
    setInputValue(event);
  };
  const [editStatus] = useState(isEdit());
  useEffect(() => {
    if (editStatus) {
      setInputValue(true);
    }
  }, [editStatus]);
  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        centered
        width={490}
        onCancel={() => setOpenModifier(false)}
        open={openModifier}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !inputValue,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Title
          title={isEdit() ? `${t("edit-modifier")}` : `${t("add-modifier")}`}
        />
        {isEdit() && (
          <span className="modaltitleEdit">
            {t("edit-details-for")} {Modifier?.name}
          </span>
        )}
        <Form
          data-testid="form"
          layout="vertical"
          form={form}
          id="ModifierForm"
          onFinish={handleFinish}
        >
          <Row>
            <Col span={14} style={{ marginTop: "20px" }}>
              <Form.Item
                initialValue={Modifier?.name}
                name="name"
                label={t("modifier-name")}
                rules={[
                  {
                    required: true,
                    message: "modifier name is required",
                  },
                ]}
              >
                <InputName
                  maxLength={50}
                  onChange={handleInputChange}
                  data-testid="name"
                />
              </Form.Item>

              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="ModifierForm"
        open={open}
        setOpen={setOpen}
        name={<span>{Modifier?.name}</span>}
        title={`${t("modifieries")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
